import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavbarLink from './common/navbar-link';
import AccessControl, { ProtectedRoute } from '../services/access-control';
import { Nav } from 'react-bootstrap';
import Fa from 'react-fontawesome';
import { Link } from 'react-router-dom';
import sidebarLogo from '../img/sidebar-logo.png';
import Logo from '../img/logo.png';
import ReleaseInfoModal from '../components/common/release-info-modal';
import { getSchoolReleaseInfoData, resetSchoolReleaseInfoData } from '../actions/school-release-info';
import { userTypes, SCHOOL_USER } from '../constants/user';

const autoOpenRoutes = [
  /^\/schools(.)*/,
  /^\/candidate(.)*/,
  /^\/user-account(.)*/,
  /^\/admin(.)*/
];

const MIN_SCREEN_WIDTH_FOR_AUTO_OPEN_SIDEBAR = 992;

class Sidebar extends Component {
  constructor(props) {
    super(props);

    const documentWidth = document.body.clientWidth;

    this.state = {
      open:
        autoOpenRoutes.some(rx => rx.test(props.location.pathname)) &&
        documentWidth >= MIN_SCREEN_WIDTH_FOR_AUTO_OPEN_SIDEBAR
    };

    this.renderSchoolsSubmenu = this.renderSchoolsSubmenu.bind(this);
    this.renderSchoolAdminSubmenu = this.renderSchoolAdminSubmenu.bind(this);
    this.handleSidebarToggle = this.handleSidebarToggle.bind(this);
  }

  componentWillMount(){  
    if (this.currentUserIsInTheSchoolUserRole()) {
      this.props.getSchoolReleaseInfoData();
    }
  }

  componentWillReceiveProps(nextProp) { 
    const isOnAutoOpenRoute = autoOpenRoutes.some(rx =>
      rx.test(this.props.location.pathname)
    );
    const willBeOnAutoOpenRoute = autoOpenRoutes.some(rx =>
      rx.test(nextProp.location.pathname)
    );

    const documentWidth = document.body.clientWidth;

    if (
      !this.state.open &&
      !isOnAutoOpenRoute &&
      willBeOnAutoOpenRoute &&
      documentWidth >= MIN_SCREEN_WIDTH_FOR_AUTO_OPEN_SIDEBAR
    ) {
      this.setState({ open: true });
    }
  }

  componentWillUnmount() {
    this.props.resetSchoolReleaseInfoData();
  }

  currentUserIsInTheSchoolUserRole() {
    return this.props.authUser.get('userType') == userTypes[SCHOOL_USER];
  }

  handleSidebarToggle(e) {
    e.preventDefault();

    this.setState({ open: !this.state.open });
  }

  renderSchoolsSubmenu(isSchoolActive) {
    const { authUser } = this.props;

    if (authUser.get('schoolMembership').size === 1 || !isSchoolActive) {
      return null;
    }

    const schoolMembership = authUser.get('schoolMembership').toJS();

    return (
      <li className="subnav__wrapper">
        <Nav className="subnav">
          {schoolMembership.map((membership, key) => {
            return (
              <NavbarLink
                key={key}
                to={`/schools/${membership.schoolId}/profile`}
                path={`/schools/${membership.schoolId}`}
              >
                {membership.schoolName}
              </NavbarLink>
            );
          })}
        </Nav>
      </li>
    );
  }

  renderSchoolAdminSubmenu() {
    const { authUser } = this.props;
    const memberships = authUser
      .get('schoolMembership')
      .filter(membership =>
        AccessControl.can('view-admin-school', 'schools', membership.toJS())
      );

    if (memberships.size === 1) {
      return null;
    }

    return (
      <li className="subnav__wrapper">
        <Nav className="subnav">
          {memberships.map((membership, key) =>
            <NavbarLink
              key={key}
              to={`/schools/admin/${membership.get('schoolId')}/users`}
              path={`/schools/admin/${membership.get('schoolId')}`}
            >
              {membership.get('schoolName')}
            </NavbarLink>
          )}
        </Nav>
      </li>
    );
  }

  renderSidebarMenu() {
    const { authUser, schoolReleaseInfo } = this.props;
    const vacancyRoutes = [
      /\/schools\/vacancies/,
      /\/schools\/\d+\/vacancies(\/|$)/,
      /\/schools\/\d+\/candidates\/\d+\/partner(\/|$)/
    ];

    const isVacancyActive = vacancyRoutes.some(rx =>
      rx.test(this.props.location.pathname)
    );

    const schoolReleaseInfoData = schoolReleaseInfo.get('releaseInfo');

    return (
      <div className="sidebar">
        <button
          className="sidebar__close-btn"
          onClick={this.handleSidebarToggle}
        >
          <Fa name="chevron-left" />
          <span className="sr-only">CLOSE</span>
        </button>
        <div className="sidebar__logo-wrapper">
          <h1 className="sidebar__logo">
            <Link to="/public">
              <img
                className="img-responsive"
                src={sidebarLogo}
                alt="sidebarLogo"
              />
              <span className="sr-only">APLī</span>
            </Link>
          </h1>
        </div>
        <Nav className="sidebar__nav">
          <NavbarLink to="/admin/users" rule="admin:view-users">
            <i className="i-apli-profile" />{' '}
            <span className="nav-link-label">Users</span>
          </NavbarLink>
          <NavbarLink to="/admin/schools" rule="admin:view-schools">
            <i className="i-apli-graduation-cap" />{' '}
            <span className="nav-link-label">Schools</span>
          </NavbarLink>
          <NavbarLink to="/admin/reports" rule="admin:view-reports">
            <i className="i-apli-stats" />{' '}
            <span className="nav-link-label">Reports</span>
          </NavbarLink>
          <NavbarLink to="/admin/audit" rule="admin:view-audit">
            <i className="i-apli-portfolio" />{' '}
            <span className="nav-link-label">Audit</span>
          </NavbarLink>
          <NavbarLink
            to="/candidate/my-applications"
            rule="candidate:view-applications"
          >
            <i className="i-apli-notepad" />{' '}
            <span className="nav-link-label">My Applications</span>
          </NavbarLink>
          <NavbarLink
            to="/candidate/my-references"
            rule="candidate:view-references"
          >
            <i className="i-apli-message" />{' '}
            <span className="nav-link-label">My References</span>
          </NavbarLink>
          <NavbarLink
            to="/candidate/my-profile"
            rule="candidate:view-references"
          >
            <i className="i-apli-profile" />{' '}
            <span className="nav-link-label">My Profile</span>
          </NavbarLink>

          <NavbarLink to="/schools/dashboard" rule="schools:view-dashboard">
            <i className="i-apli-dashboard" />{' '}
            <span className="nav-link-label">Dashboard</span>
          </NavbarLink>
          <NavbarLink
            exact
            to="/schools/vacancies"
            active={isVacancyActive}
            rule="schools:view-vacancies"
          >
            <i className="i-apli-notepad-2" />{' '}
            <span className="nav-link-label">Vacancies</span>
          </NavbarLink>
          <NavbarLink exact to="/schools" rule="schools:view">
            <i className="i-apli-graduation-cap" />{' '}
            <span className="nav-link-label">
              {authUser.get('schoolMembership').size === 1
                ? 'School'
                : 'Schools'}
            </span>
          </NavbarLink>

          <ProtectedRoute
            exact
            path="/schools"
            rule="schools:view"
            component={() => this.renderSchoolsSubmenu(!isVacancyActive)}
          />
          <ProtectedRoute
            path="/schools/:schoolId(\d+)"
            rule="schools:view"
            component={() => this.renderSchoolsSubmenu(!isVacancyActive)}
          />

          <NavbarLink to="/schools/reports" rule="schools:view-reports">
            <i className="i-apli-stats" />{' '}
            <span className="nav-link-label">Reports</span>
          </NavbarLink>

          <NavbarLink to="/schools/admin" rule="schools:view-admin">
            <i className="i-apli-portfolio" />{' '}
            <span className="nav-link-label">Admin</span>
          </NavbarLink>

          <ProtectedRoute
            exact
            path="/schools/admin"
            rule="schools:view-admin"
            component={this.renderSchoolAdminSubmenu}
          />
          <ProtectedRoute
            path="/schools/admin/:schoolId(\d+)"
            rule="schools:view-admin"
            component={this.renderSchoolAdminSubmenu}
          />
        </Nav>

        {this.currentUserIsInTheSchoolUserRole() && schoolReleaseInfoData && 
          <ReleaseInfoModal releaseInfo={schoolReleaseInfoData.toJS()}/>
        }
      </div>
    );
  }

  renderSidebarButton() {
    const { pathname } = this.props.location;

    const isPublicPage = /^\/public($|\/$)/.test(pathname);
    const pathToLogo = isPublicPage ? sidebarLogo : Logo;
    
    return (
      <div className={`sidebar-default-nav ${isPublicPage ? 'sidebar-default-nav_home' : ''}`}>
        <button
          className={`sidebar__open-btn ${isPublicPage ? 'sidebar__open-btn_home' : ''}`}
          onClick={this.handleSidebarToggle}
        >
          <Fa name="bars" />
          <span className="sr-only">OPEN Sidebar</span>
        </button>
        <div className="sidebar__logo-default-wrapper">
          <h1 className="sidebar__logo_default">
            <Link to="/public">
              <img
                className="img-responsive hidden-xs"
                src={pathToLogo}
                alt="Logo"
              />
              <img
                className="img-responsive hidden-sm hidden-md hidden-lg"
                src={Logo}
                alt="Logo"
              />
              <span className="sr-only">APLī</span>
            </Link>
          </h1>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.open) {
      return this.renderSidebarMenu();
    }

    return this.renderSidebarButton();
  }
}

export default connect(
  state => ({
    authUser: state.authUser,
    schoolReleaseInfo: state.schoolReleaseInfo
  }),
  { getSchoolReleaseInfoData, resetSchoolReleaseInfoData })(Sidebar);



// WEBPACK FOOTER //
// ./src/components/sidebar.js